import styled, { css } from "styled-components";

export const ProjectsSectionWrapper = styled.section`
  min-height: 100vh;
`;

export const ProjectsHeading = styled.h3`
  text-align: center;
  font-size: 3rem;
  margin: 3em auto 0.5em auto;
  text-align: center;
  text-decoration: underline;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const ProjectImg = styled.img`
  width: 100%;
  height: 300px;
  display: block;
  object-fit: cover;
  opacity: 0.6;
`;

export const ImgWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 300px;
`;

export const ProjectsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 98%;
  margin: 0 auto;
`;

export const SingleProjectWrapper = styled.div`
  flex: 1 1 300px;
  margin: 1em;
  padding: 1em 1em 2em 1em;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 2.6px 5.1px 5.1px hsl(0deg 0% 0% / 0.42);
  transition: 0.5s ease-in-out;

  &:hover {
    transform: scale(1.02);
  }
`;

export const ProjectHeading = styled.h4`
  margin: 1em 0;
  font-size: 1.2em;
`;

export const ProjectText = styled.p`
  margin-bottom: 2em;
  line-height: 1.5;
`;

export const ProjectLink = styled.a`
  ${({ theme }) => css`
    background-color: ${theme.colors.buttonColor};
  `}
  text-decoration: none;
  color: white;
  font-weight: 600;
  padding: 0.5em 1em;
  border-radius: 5px;
  transition: 0.2s ease-in-out;

  &:hover {
    color: #000;
    opacity: 0.8;
  }
`;
